import { Message, StatusValues, MediaItem } from '../models/message';
import { User } from '../models/user';

interface IncomingMessageData {
  MessageSid: string;
  Body: string;
  NumMedia?: string | number;
  NumSegments?: string | number;
  [key: string]: string | number | undefined; // For dynamic MediaUrl0, MediaContentType0, etc.
}

export interface BroadcastMessageData {
  sid: string;
  body: string;
  direction: string;
  from_: string;
  to: string;
  status: string;
  num_media?: string | number;
  media_url?: string[];
  sender_name?: string;
  username?: string;
  date_created?: string;
  date_sent?: string;
  date_updated?: string;
  [key: string]: unknown;
}

export function mapIncomingMessage(msg: IncomingMessageData, from: User, us: User): Message {

  const numMediaValue = msg.NumMedia ?? 0;
  const numMedia = typeof numMediaValue === 'number' ? numMediaValue : parseInt(numMediaValue, 10);
  const media: MediaItem[] = [];

  for (let i = 0; i < numMedia; i++) {
    const urlValue = msg[`MediaUrl${i}`];
    if (!urlValue) continue;
    
    const url = String(urlValue);
    const filename = new URL(url).pathname.split('/').pop()?.split('?')[0] ?? 'file';
    const contentTypeValue = msg[`MediaContentType${i}`];
    const contentType = contentTypeValue ? String(contentTypeValue) : 'application/octet-stream';
    const size = 0
    
    media.push({ url, filename, contentType, size });
  }
  return {
    sid: msg.MessageSid,
    sender: from,
    receiver: us,
    sentTimestamp: new Date(),
    content: msg.Body,
    status: StatusValues.RECEIVED,
    media: media.length > 0 ? media : undefined,
  };
}

export function isBroadcastMessage(msg: Record<string, unknown>): boolean {
  return msg['direction'] === 'outbound' && typeof msg['sid'] === 'string';
}

// TODO: There's really no need for this method. We were in a pinch 
// and didn't have time to fix the API and make a single mapping method 
// that works with both incoming and outgoing messages.

export function mapBroadcastMessage(msg: BroadcastMessageData, recipient: User): Message {
  const media: MediaItem[] = [];
  if (msg.media_url?.length) {
    for (const url of msg.media_url) {
      try {
        const filename = new URL(url).pathname.split('/').pop()?.split('?')[0] ?? 'file';
        media.push({ url, filename, contentType: '', size: 0 });
      } catch {
        media.push({ url, filename: 'file', contentType: '', size: 0 });
      }
    }
  }

  return {
    sid: msg.sid,
    sender: { name: '', phoneNumber: msg.from_ },
    receiver: recipient,
    sentTimestamp: msg.date_created ? new Date(msg.date_created) : new Date(),
    content: msg.body ?? '',
    status: (msg.status as StatusValues) ?? StatusValues.SENT,
    media: media.length > 0 ? media : undefined,
  };
}
